import { PlatformSDKShape } from '../PlatformSDKShape';
import { BaseSDKShape } from '../BaseSDKShape';
import { ApplicationContext } from '@wix/editor-platform-contexts';
import type { IRouter } from '@wix/public-editor-platform-interfaces';

export class RoutersSDKShape extends BaseSDKShape {
  constructor(
    protected overriddenApplicationContext: Promise<ApplicationContext> | null = null,
  ) {
    super(overriddenApplicationContext);
  }

  async isValidPrefix(prefix: string): Promise<boolean> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.routers.isValidPrefix(prefix);
  }

  async list(): Promise<IRouter[]> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.routers.list();
  }

  async add(extensionId: string): Promise<IRouter> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.routers.add(extensionId);
  }
}

export default new PlatformSDKShape(RoutersSDKShape)
  .withPublicMethod('isValidPrefix')
  .withPublicMethod('list')
  .withPublicMethod('add')
  .build();
